import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { logoutUser } from '../../modules/auth'

class Logout extends Component {

  componentWillMount() {
    const { dispatch } = this.props
    dispatch(logoutUser())
  }
  render() {

    return (
      <button className="btn btn-primary">
        Logout
      </button>
    )
  }

}

Logout.propTypes = {
  dispatch: PropTypes.func.isRequired
}
export default connect()(Logout)



// WEBPACK FOOTER //
// ./src/containers/logout/index.js